<template>
  <div class="news-item">
    <div class="image__wrapper">
      <picture>
        <source v-if="imageSrc.md"
          :srcset="$store.getters.apiDomain + imageSrc.md" media="(min-width: 576px)">
        <source v-if="imageSrc.lg"
          :srcset="$store.getters.apiDomain + imageSrc.lg" media="(min-width: 768px)">
        <source v-if="imageSrc.xl"
          :srcset="$store.getters.apiDomain + imageSrc.xl" media="(min-width: 992px)">
        <source v-if="imageSrc.xxl"
          :srcset="$store.getters.apiDomain + imageSrc.xxl" media="(min-width: 1200px)">
        <img
          :src="$store.getters.apiDomain + imageSrc.md"
          alt=""
          :class="{'hidden': !photoView}"
        >
      </picture>
    </div>
    <div
      v-if="!content"
      class="news-details__wrapper"
    >
      <h3>{{ title }}</h3>
      <p v-if="!formatHtml">
        {{ shortDescription }}
      </p>
      <div
        v-else
        v-html="shortDescription"
        class="news-content-html"
      />
      <div class="news-footer">
        <div class="public-date-time">
          <p class="public-date">{{ publicDate }}</p>
          <p class="public-date">{{ publicTime }}</p>
        </div>
        <router-link
          :to="{ name: 'newsPage', params: { id} }"
          class="btn-news-more"
        >
          {{ $t('news.more') }} <i class="exu-chevron-right" />
        </router-link>
      </div>
    </div>
    <div
      v-else
      class="news-details__wrapper"
    >
      <h3>{{ title }}</h3>
      <p v-if="!formatHtml">
        {{ content }}
      </p>
      <div
        v-else
        v-html="content"
        class="news-content-html"
      />
      <div>
        <div class="public-date-time">
          <p class="public-date">{{ publicDate }}</p>
          <p class="public-date">{{ publicTime }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NewsItem',
  props: {
    id: {
      type: [String, Number],
      requared: true,
    },
    imageSrc: {
      type: Object,
      default: null,
    },
    public: {
      type: Object,
      requared: true,
    },
    title: {
      type: String,
      requared: true,
    },
    shortDescription: {
      type: String,
      requared: true,
    },
    content: {
      type: String,
      default: '',
    },
    formatHtml: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    publicDate() {
      return this.public.date;
    },
    publicTime() {
      return this.public.time;
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss">
.news-item {
  padding: 0;
  border-radius: 16px;
  background-color: #fefefe;
  overflow: hidden;

  box-shadow: 0 0 8px 1px rgba(101, 16, 57, 0.15);

  .image__wrapper {
    border-radius: 16px;
  }
}
.news-details__wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px 10px 10px;

  h3, p {
    margin: 0;
    padding: 0;
  }

  h3 {
    font-size: 16px;
    font-weight: 700;
  }

  p {
    font-size: 14px;
  }

  .news-content-html {
    display: flex;
    flex-direction: column;
    gap: 10px;

    h3, p {
      margin: 0;
      padding: 0;
    }
  }

  .news-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
    margin-top: 10px;

    .public-date-time {
      flex: 0 0 auto;
      .public-date {
        font-size: 14px;
        color: #6E6E6E;
      }
    }

    .btn-news-more {
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      height: 30px;
      border: 2px solid #E62D86;
      padding: 0 10px;
      color: #E62D86;
      text-decoration: none;
      line-height: 1em;
      border-radius: 15px;

      text-transform: lowercase;
    }
  }
}
</style>
